import React__default, { createElement, useState, useEffect } from 'react';
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css';
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css';
import { parseHostname } from '@ta-interaktiv/parse-hostname';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') { return; }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".CopyrightNotice-module_copyrightNotice__qMiQo{text-align:center;display:block}.CopyrightNotice-module_copyrightNotice__qMiQo .ui.centered.image{display:block}.CopyrightNotice-module_copyrightNotice__qMiQo .ui.list{margin-top:1ex}";
var styles = {"copyrightNotice":"CopyrightNotice-module_copyrightNotice__qMiQo"};
styleInject(css);

var data = { de:{ privacyPolicy:"Datenschutz" },
  fr:{ privacyPolicy:"Déclaration de confidentialité" },
  en:{ privacyPolicy:"Privacy Policy" } };

function PureCopyrightNotice(_a) {
    var _b = _a.inverted, inverted = _b === void 0 ? false : _b, fullMediaName = _a.fullMediaName, mediaName = _a.mediaName, _c = _a.year, year = _c === void 0 ? new Date(Date.now()).getFullYear() : _c, _d = _a.displayPrivacyPolicyLink, displayPrivacyPolicyLink = _d === void 0 ? true : _d, _e = _a.locale, locale = _e === void 0 ? 'de' : _e;
    if (!mediaName) {
        return null;
    }
    return (createElement("div", { className: "copyright-notice " + styles.copyrightNotice + " " + (inverted ? 'inverted' : '') },
        createElement("a", { href: "//www." + mediaName + ".ch/", className: 'ui mini centered image' },
            createElement("img", { src: "//interaktiv.tagesanzeiger.ch/static/icons/" + mediaName + (inverted ? '-inverted' : '') + ".svg", alt: '' })),
        createElement("div", { className: "ui horizontal divided tiny link " + (inverted ? 'inverted' : '') + " list" },
            createElement("a", { href: "https://www." + mediaName + ".ch/", className: 'item' },
                "\u00A9 ",
                year,
                " ",
                fullMediaName),
            displayPrivacyPolicyLink && (createElement("a", { href: "https://abo." + mediaName + ".ch/tamstorefront/terms/register", className: 'item' }, data[locale].privacyPolicy)))));
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0
THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.
See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var API_SUBDOMAIN = 'm';
var API_ENDPOINT = '/api/sites/default';
var CopyrightInfoError = (function (_super) {
    __extends(CopyrightInfoError, _super);
    function CopyrightInfoError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CopyrightInfoError;
}(Error));
function PolymorphicCopyrightNotice(props) {
    var _a = useState({}), downloadedData = _a[0], setData = _a[1];
    useEffect(function () {
        if (process.env.NODE_ENV === 'development' &&
            !process.env.STORYBOOK_STATE) {
            console.group('Polymorphic Copyright Notice');
            console.log('In development mode.');
            console.groupEnd();
            setData({
                fullMediaName: 'Local Host',
                mediaName: 'localhost'
            });
            return;
        }
        if (props.mediaName && props.fullMediaName) {
            return;
        }
        var secondLevelDomainName = props.mediaName || parseHostname().publicationName;
        fetch("https://" + API_SUBDOMAIN + "." + secondLevelDomainName + ".ch" + API_ENDPOINT)
            .then(function (response) {
            if (!response.ok) {
                throw new CopyrightInfoError(response.statusText);
            }
            return response.json();
        })
            .then(function (data) {
            var siteInformation = data.site;
            setData({
                mediaName: secondLevelDomainName,
                fullMediaName: props.fullMediaName || siteInformation.name,
                locale: props.locale || siteInformation.language
            });
        })
            .catch(function (error) {
            console.group('Polymorphic Copyright Notice');
            console.warn('The external services endpoint could not be reached (or threw up for some other reason).');
            console.log(error.message, error);
            console.groupEnd();
            setData({
                mediaName: secondLevelDomainName
            });
        });
    }, [props.mediaName]);
    return React__default.createElement(PureCopyrightNotice, __assign({}, props, downloadedData));
}

export default PolymorphicCopyrightNotice;
export { PolymorphicCopyrightNotice as CopyrightNotice, PolymorphicCopyrightNotice, PureCopyrightNotice };
//# sourceMappingURL=index.js.map
